import { render, staticRenderFns } from "./obiettivi.html?vue&type=template&id=268a1a76&scoped=true&"
import script from "./Obiettivi.vue?vue&type=script&lang=js&"
export * from "./Obiettivi.vue?vue&type=script&lang=js&"
import style0 from "./Obiettivi.vue?vue&type=style&index=0&id=268a1a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268a1a76",
  null
  
)

export default component.exports